module.exports = Vuex;


//////////////////
// WEBPACK FOOTER
// external "Vuex"
// module id = 690
// module chunks = 